import { render, staticRenderFns } from "./CookiePreferencesModal.vue?vue&type=template&id=040e79f0&scoped=true"
import script from "./CookiePreferencesModal.vue?vue&type=script&lang=js"
export * from "./CookiePreferencesModal.vue?vue&type=script&lang=js"
import style0 from "./CookiePreferencesModal.vue?vue&type=style&index=0&id=040e79f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e79f0",
  null
  
)

export default component.exports